import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["search", "playlistIds", "assetIds"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import { useQuery } from 'react-query';
import api from 'utils/api';
import contentKeys from './queryKeys';
function useFetchContentUsersAndTeams(_ref) {
  var search = _ref.search,
    playlistIds = _ref.playlistIds,
    assetIds = _ref.assetIds,
    queryOptions = _objectWithoutProperties(_ref, _excluded);
  function fetchTeamsAndUsers() {
    return _fetchTeamsAndUsers.apply(this, arguments);
  }
  function _fetchTeamsAndUsers() {
    _fetchTeamsAndUsers = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return api('get', '/api/teams-or-users', {
              query: search,
              playlistIds: playlistIds,
              assetIds: assetIds
            });
          case 2:
            data = _context.sent;
            return _context.abrupt("return", data);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _fetchTeamsAndUsers.apply(this, arguments);
  }
  return useQuery(contentKeys.contentUsersAndTeams(search, playlistIds, assetIds), fetchTeamsAndUsers, _objectSpread({
    staleTime: 5 * 60 * 1000
  }, queryOptions));
}
export default useFetchContentUsersAndTeams;